export default __webpack_public_path__ + "static/media/emergency-warning-white.abbfb976.png";